import { render } from "./VIPCreate.vue?vue&type=template&id=0686da7b&scoped=true"
import script from "./VIPCreate.vue?vue&type=script&lang=js"
export * from "./VIPCreate.vue?vue&type=script&lang=js"

import "./VIPCreate.vue?vue&type=style&index=0&id=0686da7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0686da7b"]])

export default __exports__